import RecentlyViewedJobsTable from "@/components/recently_viewed_jobs/table";
import "./recently_viewed_jobs_widget.scss";
import { SectionTitle } from "@/sprout/typography";
import ArrowRightIcon from "@/sprout/icons/arrow_right";
import { Link } from "@inertiajs/react";
import useTranslation from "@hooks/use_translation";
import { useCallback } from "react";
import { DashboardSuspense } from "../dashboard_suspense";
import useRecentlyViewedJobs from "@/queries/use_recently_viewed_jobs.ts";
import { useDashboardPreview } from "../preview_context";

type Props = {
  path: string;
  perPage: number;
};

const renderHeader = (path: string) => {
  const { t } = useTranslation("recentlyViewedJobs");

  return (
    <Link href={path} className="recently-viewed-jobs_card__header">
      <SectionTitle>{t("header")}</SectionTitle>
      <div className="recently-viewed-jobs_card__header__icon">
        <ArrowRightIcon />
      </div>
    </Link>
  );
};

const RecentlyViewedJobsWidget = ({ path, perPage }: Props) => {
  const { preview } = useDashboardPreview();
  const renderHeaderFunc = useCallback(() => renderHeader(path), [path]);

  const { data: jobs } = useRecentlyViewedJobs({ mock: preview });

  return (
    <div className="recently-viewed-jobs_card">
      <DashboardSuspense renderHeader={renderHeaderFunc}>
        {renderHeaderFunc()}
        <RecentlyViewedJobsTable
          hideHeader={true}
          perPage={perPage}
          forceMobileView={true}
          isWidgetMode
          jobs={jobs}
        />
      </DashboardSuspense>
    </div>
  );
};

export default RecentlyViewedJobsWidget;
